module.exports = __webpack_public_path__ + "img/preview-block.230de8e3.svg";